import React from "react";
import './HomeScreenAccountInfoCard.css';
import FullPagePanel from "components/reusable/FullPagePanel";
import AccountSettingsTabs from "components/account-screen/AccountSettingsTabs";
import LoginForm from "components/account-screen/LoginForm";
import Constants from "utilities/js/Constants";
import CookieManager from "utilities/js/localstorage/CookieManager";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import { isLoggedIn } from "utilities/js/ActionLibrary";

const accountIcon = Constants.ICON_ACCOUNT;
const EditIcon = Constants.ICON_EDIT;

const cookieManager = new CookieManager();

class HomeScreenAccountInfoCard extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            isOpen: false
        };
        this.toggleAccountPanel = this.toggleAccountPanel.bind(this);
        this.closeAccountPanel = this.closeAccountPanel.bind(this);
        this.getAccountPanelDisplay = this.getAccountPanelDisplay.bind(this);
    }

    toggleAccountPanel(){
        if(this.state.isOpen){
            this.setState({isOpen: false});
            unfreezeBody();
        }else{
            this.setState({isOpen: true});
            freezeBody();
        }
    }

    closeAccountPanel(){
        this.setState({isOpen: false});
        unfreezeBody();
    }
    
    getAccountPanelDisplay(){
        if(isLoggedIn()){
            return (<AccountSettingsTabs></AccountSettingsTabs>)
        }else{
            return (<LoginForm closePanel={this.closeAccountPanel}></LoginForm>);
        }
    }

    get accountButton(){
        
        let username = cookieManager.getValue(Constants.COOKIE_USERNAME_KEY);
        let email = cookieManager.getValue(Constants.COOKIE_USER_EMAIL_KEY);

        if(username){            
            return (
                <div key="account-panel" className="account-panel-container name-display">
                    <div className="account-info-panel-container" onClick={this.toggleAccountPanel}>
                        <div className="home-account-icon-container">
                            <img src={accountIcon} className="home-account-icon account-icon"></img>
                        </div>
                        <div className="account-info-control-username">{username}</div>
                    </div>
                </div>
            )
        }else{
            return (
                <div key="login-register-button" className="login-register-button-container">
                    <div className="login-register-button" onClick={this.toggleAccountPanel}>Register / Login</div>
                </div>
            );
        }
    }

    render(){

        return (<>
            {this.accountButton}
            <FullPagePanel key="full-page-panel" shouldDisplay={this.state.isOpen} closePanel={this.closeAccountPanel}> 
                {this.getAccountPanelDisplay()}
            </FullPagePanel>
        </>);
    }
}

export default HomeScreenAccountInfoCard;
